import { render, staticRenderFns } from "./icon-google-play.vue?vue&type=template&id=68fa9e1b&"
import script from "./icon-google-play.vue?vue&type=script&lang=js&"
export * from "./icon-google-play.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports